import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Swal from "sweetalert2";

export default function ContactUs() {
  const branches = [
    {
      city: "Ahmedabad",
      address:
        "1016, Anand Mangal – III, Opp Core House, Apollo City Centre Lane, Ambawadi, Ahmedabad, Gujarat – 380015",
      phone: "+91 99251 53132",
    },
    {
      city: "Mumbai",
      address:
        "G172, Corporate Wing, Haware Fantasia Business Park, Sector 30A, Behind Inorbit Mall, Vashi, Maharashtra, 400705",
      phone: "+91 98211 06883",
    },
    {
      city: "Bhilwara",
      address:
        "1st Floor, Gurunanak Bhawan, Near Gurudwara, Sindhu Nagar, Bhilwara, Rajasthan, 311001",
      phone: "+91 99828 45321",
    },
  ];

  /* ================= FORM STATE ================= */
  const [form, setForm] = useState({
    name: "",
    company_name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // ✅ LOADER STATE

  /* ================= VALIDATION ================= */
  const validate = () => {
    let newErrors = {};

    if (!form.name || form.name.length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(form.phone)) {
      newErrors.phone = "Phone must be 10 digits.";
    }

    if (!form.message || form.message.length < 10) {
      newErrors.message = "Message must be at least 10 characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================= INPUT HANDLER ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* ================= SUBMIT HANDLER ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      Swal.fire("Validation Error", "Please check your inputs.", "warning");
      return;
    }

    setLoading(true); // ✅ START LOADER

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/contact/send`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const data = await res.json();

      if (res.ok && data.success) {
        Swal.fire("Success 🎉", "Message sent successfully.", "success");

        setForm({
          name: "",
          company_name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        Swal.fire("Error", data.message || "Mail not sent.", "error");
      }
    } catch (error) {
      Swal.fire("Server Error", "Please try again later.", "error");
    } finally {
      setLoading(false); // ✅ STOP LOADER
    }
  };

  return (
    <>
      <Header />

      {/* HERO */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/assets/img/contact.jpeg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Contact Us</h1>
          <p>
            We’d love to hear from you. Let’s discuss how we can help with your
            accounting, audit, and tax needs.
          </p>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-container">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>Our team is always available to assist you.</p>

          <ul className="info-list">
            <li>
              <span>📍</span>
              <div>
                <strong>Office Address:</strong> <br />
                1016, Anand Mangal – III, Opp Core House, Apollo City Centre
                Lane, Ambawadi, Ahmedabad, Gujarat – 380015
              </div>
            </li>

            <li>
              <span>📞</span>
              <div>
                <strong>Phone:</strong> +91 79489 71100
              </div>
            </li>

            <li>
              <span>📧</span>
              <div>
                <strong>Email:</strong> office@sdpmco.com
              </div>
            </li>

            {/* ✅ Office Hours Added */}
            <li>
              <span>🕒</span>
              <div>
                <strong>Office Hours:</strong> <br />
                Monday to Saturday – 10:30 AM to 7:30 PM
              </div>
            </li>
          </ul>
        </div>

        {/* FORM */}
        <div className="contact-form">
          <h2>Send Us a Message</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="input-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={form.name}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only letters and spaces
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                />
                {errors.name && <p className="error-text">{errors.name}</p>}
              </div>

              <div className="input-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>
            </div>

            <div className="form-row">
              <div className="input-group">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={form.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="error-text">{errors.phone}</p>}
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="company_name"
                  placeholder="Company Name"
                  value={form.company_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="input-group">
              <textarea
                name="message"
                rows="6"
                placeholder="Your Message"
                value={form.message}
                onChange={handleChange}
              />
              {errors.message && <p className="error-text">{errors.message}</p>}
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>

      {/* BRANCHES */}
      <section className="branch-section">
        <div className="container">
          <h2 className="branch-title">Our Branch Offices</h2>

          <div className="branch-grid">
            {branches.map((branch, index) => (
              <div key={index} className="branch-card">
                <h3>{branch.city}</h3>
                <p>{branch.address}</p>
                <p>
                  <strong>📞</strong> {branch.phone}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GOOGLE MAP */}
      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.8119098864054!2d72.55021998084428!3d23.018033762826956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84e325c26985%3A0x47da16a1b753a025!2sAnand%20Mangal%203!5e1!3m2!1sen!2sin!4v1765970690212!5m2!1sen!2sin"
          width="100%"
          height="450"
          title="Anand Mangal 3"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>

      <Footer />
    </>
  );
}
